import { FC, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box, Container, HStack, Image, rem } from '@bonusly/design-system';

import logo from '../../assets/images/bonusly-logo.png';
import { PageLoading } from '../loading';

// Session-free shell for the unauthenticated public form. Cloned from
// NavlessLayout's visual structure (sticky logo header + centered content) but
// with EVERY identity hook stripped — no useCurrentCompany, no useCurrentUser,
// no spoofing/seasonal logo. It renders for an anonymous visitor with an empty
// identity store, so it must not read any user/company state. The Bonusly logo
// is used unconditionally because there is no company context to source a custom
// logo from.
export const PublicLayout: FC = () => {
	return (
		<Box bg="bg.surface" display="flex" flexDirection="column" minH="100vh" minW={rem(370)}>
			<Box
				bg="bg.surface"
				borderBottomColor="border.default"
				borderBottomStyle="solid"
				borderBottomWidth="1px"
				position="sticky"
				top="0"
				w="100%"
				zIndex="docked"
			>
				<Container maxW={'100%'} px={4}>
					<HStack h={16} align="center" maxW={72}>
						<Box h={rem(46)}>
							<Image alt="Bonusly" h="full" objectFit="contain" src={logo} />
						</Box>
					</HStack>
				</Container>
			</Box>

			<Box display="flex" flexDirection="column" flexGrow={1} pos="relative" zIndex="base">
				<Suspense fallback={<PageLoading />}>
					<Outlet />
				</Suspense>
			</Box>
		</Box>
	);
};
